import { createDeformedCube, depthRatio, CUBE_PARAMS } from "./CubeBase";

// 誤り3: 上面の辺の角度誤り
// 上面左と右の後退辺を正しい角度より垂直寄り（平均24.2度）に回転させる誤り。
// デッサンを正とすると、上面の左奥の辺が左に傾いている立体になる。
// shearValue=0.5 で平面視のせん断角 atan(0.5)≈26.6度となり、文献の24.2度に概ね対応する。
// shearValue: 0=正解(立方体), 0.5=誤り, 0.2=中間
export function createCubeModel3(shearValue, faceColors, errorEdges) {
  shearValue = shearValue !== undefined ? shearValue : 0.5;
  const half = CUBE_PARAMS.size / 2;
  return createDeformedCube((x, y, z) => [
    // 上面の左右奥の辺のみが内側にずれる
    x +  (z > 0&& y > 0&& x > 0 ? 1.0*shearValue * depthRatio(z) * half : 0),
    y +  (z > 0&& y > 0&& x < 0 ? 0.5*1.0*shearValue * depthRatio(z) * half : 0),
    z +  (z > 0&& y > 0&& x < 0 ? -1.0*shearValue * depthRatio(z) * half : 0),
  ], faceColors, errorEdges);
}
